/* Open the nickname-capable product review form from order history. */
(() => {
  const url = new URL(location.href);
  if (url.searchParams.get('review') !== 'write') return;
  let opened = false;
  const observer = new MutationObserver(open);
  const timeout = setTimeout(() => observer.disconnect(), 20000);
  function open() {
    const button = document.querySelector('#judgeme_product_reviews [data-testid="write-review-button"]');
    if (opened || !button || button.disabled || !button.getClientRects().length) return;
    opened = true;
    observer.disconnect();
    clearTimeout(timeout);
    button.click();
  }
  observer.observe(document.documentElement, { childList: true, subtree: true });
  open();
})();
